module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (1).ccd3b9c1.svg";